import React from "react";
import { TextVariant, TypographyNew } from "../typography/typography";
import AbsenseNotificationBody from "./AbsenceNotificationBody";
import NotificationNameLink from "./NotificationNameLink";
import { colors } from "../../utils";
import {
  NotificationCardData,
  getEventLink,
  getIsAbsenceType,
} from "./notification";
import BaseNotificationBody from "./BaseNotificationBody";
import LinkStyled from "../buttonsLinks/LinkStyled";
import { useGeneralState } from "../../redux/general/selectors";

type NotificationCardProps = {
  title: string;
  data?: NotificationCardData;
  body?: string;
};

function getNotificationBodyByType(
  type?: NotificationCardData["event"]["type"]
) {
  const isAbsentType = getIsAbsenceType(type);

  if (isAbsentType) {
    return AbsenseNotificationBody;
  }

  return BaseNotificationBody;
}

export default function NotificationCard({
  data,
  title,
  body,
}: NotificationCardProps): JSX.Element {
  const general = useGeneralState();
  const eventLink = getEventLink(general.userSelection.type, data);
  const NotificationBody = getNotificationBodyByType(data?.event?.type);

  return (
    <>
      <TypographyNew variant={TextVariant.subtitle2} color={colors.gray1}>
        {eventLink ? <LinkStyled to={eventLink}>{title}</LinkStyled> : title}
      </TypographyNew>
      {data ? (
        <>
          <TypographyNew
            variant={TextVariant.subtitle2}
            marginTop={"10px"}
            color={colors.blue1}
          >
            <NotificationNameLink data={data} />
          </TypographyNew>
          <NotificationBody event={data.event} body={body} />
        </>
      ) : null}
    </>
  );
}
